export enum NumberChoiceType {
  numbers,
  points,
  matrixFind,
  matrixBlank,
  matrixFill,
};

export interface NumberUnit {
  sectionNo: number;
  unitNo: number;
  stndardSec: number;
  choiceType: NumberChoiceType;
  choiceCount: number;
};

export const NUMBER_UNITS: NumberUnit[] = [
  {
    sectionNo: 1,
    unitNo: 1,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 5
  },
  {
    sectionNo: 1,
    unitNo: 2,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 10
  },
  {
    sectionNo: 1,
    unitNo: 3,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 10
  },
  {
    sectionNo: 1,
    unitNo: 4,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 5
  },
  {
    sectionNo: 1,
    unitNo: 5,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 10
  },
  {
    sectionNo: 1,
    unitNo: 6,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 10
  },
  {
    sectionNo: 2,
    unitNo: 1,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 15
  },
  {
    sectionNo: 2,
    unitNo: 2,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 15
  },
  {
    sectionNo: 2,
    unitNo: 3,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 20
  },
  {
    sectionNo: 2,
    unitNo: 4,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 20
  },
  {
    sectionNo: 2,
    unitNo: 5,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 15
  },
  {
    sectionNo: 2,
    unitNo: 6,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 15
  },
  {
    sectionNo: 2,
    unitNo: 7,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 20
  },
  {
    sectionNo: 2,
    unitNo: 8,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 20
  },
  {
    sectionNo: 3,
    unitNo: 1,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 25
  },
  {
    sectionNo: 3,
    unitNo: 2,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 25
  },
  {
    sectionNo: 3,
    unitNo: 3,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 30
  },
  {
    sectionNo: 3,
    unitNo: 4,
    stndardSec: 100,
    choiceType: NumberChoiceType.numbers,
    choiceCount: 30
  },
  {
    sectionNo: 3,
    unitNo: 5,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 25
  },
  {
    sectionNo: 3,
    unitNo: 6,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 25
  },
  {
    sectionNo: 3,
    unitNo: 7,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 30
  },
  {
    sectionNo: 3,
    unitNo: 8,
    stndardSec: 100,
    choiceType: NumberChoiceType.points,
    choiceCount: 30
  },
  {
    sectionNo: 4,
    unitNo: 1,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 30
  },
  {
    sectionNo: 4,
    unitNo: 2,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 40
  },
  {
    sectionNo: 4,
    unitNo: 3,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 50
  },
  {
    sectionNo: 4,
    unitNo: 4,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 60
  },
  {
    sectionNo: 4,
    unitNo: 5,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 70
  },
  {
    sectionNo: 4,
    unitNo: 6,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 80
  },
  {
    sectionNo: 4,
    unitNo: 7,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 90
  },
  {
    sectionNo: 4,
    unitNo: 8,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 100
  },
  {
    sectionNo: 4,
    unitNo: 9,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 110
  },
  {
    sectionNo: 4,
    unitNo: 10,
    stndardSec: 60,
    choiceType: NumberChoiceType.matrixFind,
    choiceCount: 120
  },
  {
    sectionNo: 5,
    unitNo: 1,
    stndardSec: 120,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 30
  },
  {
    sectionNo: 5,
    unitNo: 2,
    stndardSec: 160,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 40
  },
  {
    sectionNo: 5,
    unitNo: 3,
    stndardSec: 200,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 50
  },
  {
    sectionNo: 5,
    unitNo: 4,
    stndardSec: 240,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 60
  },
  {
    sectionNo: 5,
    unitNo: 5,
    stndardSec: 280,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 70
  },
  {
    sectionNo: 5,
    unitNo: 6,
    stndardSec: 320,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 80
  },
  {
    sectionNo: 5,
    unitNo: 7,
    stndardSec: 360,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 90
  },
  {
    sectionNo: 5,
    unitNo: 8,
    stndardSec: 400,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 100
  },
  {
    sectionNo: 5,
    unitNo: 9,
    stndardSec: 440,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 110
  },
  {
    sectionNo: 5,
    unitNo: 10,
    stndardSec: 480,
    choiceType: NumberChoiceType.matrixBlank,
    choiceCount: 120
  },
  {
    sectionNo: 6,
    unitNo: 1,
    stndardSec: 120,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 30
  },
  {
    sectionNo: 6,
    unitNo: 2,
    stndardSec: 160,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 40
  },
  {
    sectionNo: 6,
    unitNo: 3,
    stndardSec: 200,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 50
  },
  {
    sectionNo: 6,
    unitNo: 4,
    stndardSec: 240,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 60
  },
  {
    sectionNo: 6,
    unitNo: 5,
    stndardSec: 280,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 70
  },
  {
    sectionNo: 6,
    unitNo: 6,
    stndardSec: 320,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 80
  },
  {
    sectionNo: 6,
    unitNo: 7,
    stndardSec: 360,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 90
  },
  {
    sectionNo: 6,
    unitNo: 8,
    stndardSec: 400,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 100
  },
  {
    sectionNo: 6,
    unitNo: 9,
    stndardSec: 440,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 110
  },
  {
    sectionNo: 6,
    unitNo: 10,
    stndardSec: 480,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 1,
    stndardSec: 450,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 2,
    stndardSec: 420,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 3,
    stndardSec: 390,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 4,
    stndardSec: 360,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 5,
    stndardSec: 330,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 6,
    stndardSec: 300,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 7,
    stndardSec: 270,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 8,
    stndardSec: 250,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 9,
    stndardSec: 230,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
  {
    sectionNo: 7,
    unitNo: 10,
    stndardSec: 210,
    choiceType: NumberChoiceType.matrixFill,
    choiceCount: 120
  },
];
